module.exports = __webpack_public_path__ + "img/icon-enterprise-blue-small.8e71fd4d.svg";